import { getDaysBetweenDates, getMonthsBetweenDates, getMonthDays, k_dateType } from '../dashboard/components/utils'
import { getControlNodeAllStatusAPI } from "@/services"
import { useRequest } from "ahooks"
import type { MilestoneRender } from '../milestone/index'
import { parseTime } from '@/utils'

export const enum k_dateWidth {
    week = 158,
    month = 58,
    season = 100,
    year = 158
}
export const handleDate = (type: k_dateType = k_dateType.month, start: Date, end: Date) => {

    let days = [];
    let currentDate = new Date(start.getTime());
    const allDays = getDaysBetweenDates(start, end)
    const years = []
    const months = []

    const startYear = start.getFullYear()
    const startMonth = start.getMonth() + 1
    const startDay = start.getDate()
    if (startDay !== 1) {
        months.push({
            leftCount: 0,
            year: startYear,
            month: startMonth,
            days: getMonthDays(start)
        })
    }
    if (startDay !== 1 || startMonth !== 1) {
        years.push({
            year: startYear,
            leftCount: 0,
            leftStr: "0%"
        })
    }
    const weeks = []
    let weekStart
    let day = 0
    let month = 0
    let year = 0
    while (currentDate <= end) {
        day = currentDate.getDate()
        if (!weekStart) {
            weekStart = day
        }
        if (day === 1) {

            let lc = 0
            if (type === k_dateType.month || type === k_dateType.week) {
                lc = days.length
            } else if (type === k_dateType.season) {
                lc = days.length / 7
            } else if (type === k_dateType.year) {
                lc = getMonthsBetweenDates(start, currentDate)
            } else if (type === k_dateType.all) {
                lc = getMonthsBetweenDates(start, currentDate)
            }
            month = currentDate.getMonth() + 1
            year = currentDate.getFullYear()

            if (month === 1) {
                years.push({
                    year: year,
                    leftCount: months.length,
                    leftStr: (getDaysBetweenDates(start, currentDate) / allDays) * 100 + "%"
                })
            }

            months.push({
                leftCount: lc,
                month: month,
                year: year,
                days: getMonthDays(currentDate)
            })

        }
        days.push(day);
        if (days.length % 7 === 0) {
            weeks.push({
                start: weekStart,
                end: day
            })
            weekStart = undefined
        }

        currentDate.setDate(day + 1);
    }
    if (weekStart) {
        weeks.push({
            start: weekStart,
            end: end.getDate()
        })
        weekStart = undefined
    }
    return {
        days: days,
        months,
        weeks,
        years
    }
}
export const useNodeStatus = () => {
    const { data: allStatus = [] } = useRequest(getControlNodeAllStatusAPI)

    const getStatusLabel = (statusNum: number) => {
        if (allStatus.length === 0) return "未知"
        return allStatus.find(s => s.nodeStatus === statusNum)?.name || "未知"
    }

    return {
        allStatus,
        getStatusLabel
    }
}
export const getDateWidth = (type: k_dateType) => {
    switch (type) {
        case k_dateType.week:
            return k_dateWidth.week
        case k_dateType.month:
            return k_dateWidth.month
        case k_dateType.season:
            return k_dateWidth.season
        case k_dateType.year:
            return k_dateWidth.year
    }
    return k_dateWidth.month
}
export const lineNodeConfig = {
    nodeHeight: 14,
    top: 10,
    lineHeight: 100
}
export const getNodeStatusColor = (statusLabel: string) => {
    if (statusLabel === "未开始") return "#333333"
    if (statusLabel === "进行中") return "rgb(252,162,16)"
    if (statusLabel === "已完成") return "#00CD66"
    return "#999999"
}
export interface CalendarMonth {
    leftCount: number, //以当前刻度，左边的刻度数
    month: number,  // 当前月
    year: number,  // 当前年
    days: number,   //本月总天数
}
export interface CalendarParams {
    contentW?: number,
    start: number,
    end: number,
    allStart: number,
    allEnd: number
    cols: string[],
    months: CalendarMonth[],
    days: number[],
    totalDays: number, //所有天数
    weeks: {
        start: number,  // 此周开始的天
        end: number  // 此周结束的天
    }[],
    years: {
        year: number,  // 当前年
        leftCount: number  // 左边的月数
        leftStr: string
    }[]
}
export const getFormateDate = (date: string) => {
    return date ? parseTime(new Date(date), '{y}-{m}-{d}') : date
}
export const k_renderLineType = {
    default: 'default',
    milestone: 'milestone',
    importMilestone: 'importMilestone',
    payment: 'payment',
    expense: 'expense',
    special: 'special',
} as const
export enum k_renderNodeShape{
    triangle = 0,
    paintDoubleCircle = 1,
    doubleCircle = 2,
    paintCircle = 3,
    circle = 4,

    moneyCanPay = 5,
    moneyBill = 6,
    moneyPartPaid = 7,
    moneyUnpaid = 8,
    moneyPaid = 9
}
export const getMoneyColor = (shape: number, defaultColor = "") => {
    let color = defaultColor
    if (shape === k_renderNodeShape.moneyPaid) {
        color = "#00a854"
    } else if (shape === k_renderNodeShape.moneyPartPaid) {
        color = "#a1a104"
    } else if (shape === k_renderNodeShape.moneyBill) {
        color = "#FFAE42"
    } else if (shape === k_renderNodeShape.moneyCanPay) {
        color = "#ff0000"
    }
    return color
}
export const getMoneyShape = (status: string) => {
    let shape = k_renderNodeShape.moneyUnpaid
    if (status === "已收款" || status === "已付款") {
        shape = k_renderNodeShape.moneyPaid
    } else if (status === "部分收款" || status === "部分付款") {
        shape = k_renderNodeShape.moneyPartPaid
    } else if (status === "未完成" || status === "未付款") {
        shape = k_renderNodeShape.moneyUnpaid
    } else if (status === "已开票") {
        shape = k_renderNodeShape.moneyBill
    } else if (status === "可收款" || status === "可付款") {
        shape = k_renderNodeShape.moneyCanPay
    }
    return shape
}
export const getMoneyColorByStatus = (status: string) => {
    const shape = getMoneyShape(status)
    return getMoneyColor(shape)
}
export const getDefaultColor = (nodeType: string) => {
    if (nodeType === k_renderLineType.milestone) return '#047857'
    if (nodeType === k_renderLineType.payment) return '#FCA210'
    return '#333333'
}
export type RenderSubMilestone = RenderDateItem & { milestoneList?: API.Project.Package[] }
export interface RenderDateItem {
    title: string,
    start?: string,
    end?: string,
    progress?: number,
    left?: number,
    leftStr?: string,
    widthStr?: string,
    right?: number,
    width?: number,
    days?: number,
    textOut?: boolean,
    textLeft?: boolean,
    dayOut?: boolean,
    showLeftArrow?: boolean,
    showRightArrow?: boolean,
    isMilestone?: boolean,
    isStandard?: boolean,
    isTimeNull?: boolean,
    data?: API.Project.Package,
    // 同一天多个里程碑
    childrens?: RenderSubMilestone[],
}
export interface Option {
    value: string;
    label: string;
    children?: Option[];
}
export interface NodePosition{
    x1: string | number;
    y1: string | number;
    x2: string | number;
    y2: string | number;
}
interface NodeBase {
    pos: string;
    percent: number;
    formatDate: string;
    isOutDate: boolean;
    isCompleted: boolean;
    nodeLabel: string;
    isDraw: boolean;
    isDds: boolean;
    nodeType: string;
}
export interface RenderNodeBase {
    uuid: string;
    pos: string;
    percent: number;
    shape: number;
    children: RenderLineNode[];
}
// 普通节点（继承ControlNode和基础字段）
export type DefaultNode = API.PROJECT.ControlNode & NodeBase

// 里程碑节点（只继承基础字段）
export type MilestoneNode = MilestoneRender & NodeBase

// 支付节点（只继承基础字段）
export type PaymentNode = API.PROJECT.SalesContractNode & NodeBase
// 费用节点，公司给客户的费用
export type ExpenseNode = API.PROJECT.ContractExpense & { date: string, status?: string, links?: (API.PROJECT.PaymentExpenseLink & {label?: string})[] } & NodeBase
export type SpecialLineNode = NodeBase & {
    name: string;
    date: string;
    status?: string;
}
export type SpecialLineNodeData = {
    name: string;
    date: string;

}
// 所有可能节点的联合类型
export type RenderLineNode = DefaultNode | MilestoneNode | PaymentNode | ExpenseNode | SpecialLineNode;
interface RenderLineBase{
    uuid: string,
    lineID: number | string,
    lineName: string,
    leftPos: string,
    width: string,
    completedWidth: string | number,
    nodeType: string;
    renderNodes: RenderNodeBase[] 
}
export interface RenderLineDefault extends API.PROJECT.ControlNodeLine, RenderLineBase{

}
export interface RenderLineMilestone extends RenderLineBase{

}
export interface RenderLinePay extends RenderLineBase{

}
export interface RenderLineExpense extends RenderLineBase{}
export interface RenderLineSpecial extends RenderLineBase{
    link: string;
}
    
export type RenderLine = RenderLineDefault | RenderLineMilestone | RenderLinePay | RenderLineExpense | RenderLineSpecial; 
export type RenderFixedLine = RenderLineMilestone | RenderLinePay | RenderLineExpense | RenderLineSpecial; 

export interface DefaultLineData extends API.PROJECT.ControlNodeLine {
    nodeType?: 'default' | 'importMilestone';
    nodes: DefaultNode[]
}
export interface MilestoneLineData extends API.PROJECT.ControlNodeLine {
    nodeType: 'milestone';
    nodes: DefaultNode[]
}
export interface PayLineData {
    nodeType: 'payment';
    contractCode: string,
    contractName: string,
    status: string
    nodes: PaymentNode[]
}
export interface ExpenseLineData {
    purContractCode: string;
    purContractName: string;
    paymentplancode: string;
    nodeType: 'expense';
    nodes: ExpenseNode[]
}
export interface SpecialLineData {
    uuid: string;
    nodeType: 'special';
    lineName: string;
    link: string;
    nodes: SpecialLineNode[]
}
export type DataSourceItem = DefaultLineData | PayLineData | MilestoneLineData | ExpenseLineData | SpecialLineData;

export function isRenderLineDefault(node: RenderLine): node is RenderLineDefault {
    return node.nodeType === 'default' || node.nodeType === "importMilestone" || !node.nodeType;
}
export function isRenderLineMilestone(node: RenderLine): node is RenderLineMilestone {
    return node.nodeType === 'milestone';
}
export function isRenderLinePay(node: RenderLine): node is RenderLinePay {
    return node.nodeType === 'payment';
}
export function isRenderLineExpense(node: RenderLine): node is RenderLineExpense {
    return node.nodeType === 'expense';
}
export function isRenderLineSpecial(node: RenderLine): node is RenderLineSpecial {
    return node.nodeType === 'special';
}

// 类型守卫函数
export function isDefaultLineData(node: DataSourceItem): node is DefaultLineData {
    return node.nodeType === 'default' || node.nodeType === "importMilestone" || !node.nodeType;
}

export function isMilestoneLineData(node: DataSourceItem): node is MilestoneLineData {
    return node.nodeType === 'milestone';
}

export function isPayLineData(node: DataSourceItem): node is PayLineData {
    return node.nodeType === 'payment';
}
export function isExpenseLineData(node: DataSourceItem): node is ExpenseLineData {
    return node.nodeType === 'expense';
}
export function isSpecialLineData(node: DataSourceItem): node is SpecialLineData {
    return node.nodeType === 'special';
}

export function parseProjectString(str: string) {
    // 正则表达式匹配模式：
    // 1. 项目编号：以字母开头，后跟数字
    // 2. 项目名称：中文、数字和空格组合
    // 3. 项目类型：以空格分隔的最后一个词或短语

    const patterns = [
        // 模式1: 编号(字母+数字) + 名称 + 空格 + 类型
        /^([A-Za-z]+\d+)([\u4e00-\u9fa5\d\s]+[^\s])\s+([\u4e00-\u9fa5]+)$/,

        // 模式2: 编号(字母+数字) + 名称（直接到结尾，没有明确类型）
        /^([A-Za-z]+\d+)([\u4e00-\u9fa5\d\s]+)$/,

        // 模式3: 纯数字编号的情况
        /^(\d+)([\u4e00-\u9fa5\d\s]+[^\s])\s+([\u4e00-\u9fa5]+)$/
    ];

    // 移除字符串首尾空格
    const trimmedStr = str.trim();
    let result = {
        code: '',
        name: '',
        type: ''
    };

    // 尝试匹配每种模式
    for (const pattern of patterns) {
        const match = trimmedStr.match(pattern);
        if (match) {
            if (match.length >= 4) {
                // 有项目类型的情况
                result.code = match[1];
                result.name = match[2].trim();
                result.type = match[3];
            } else if (match.length === 3) {
                // 没有明确项目类型的情况
                result.code = match[1];
                // 尝试从项目名称中分离出可能的类型
                const nameParts = match[2].trim().split(' ');
                if (nameParts.length > 1) {
                    result.name = nameParts.slice(0, -1).join(' ');
                    result.type = nameParts[nameParts.length - 1];
                } else {
                    result.name = match[2].trim();
                    result.type = '未知';
                }
            }
            return result;
        }
    }

    return {
        code: result.code || '',
        name: result.name || trimmedStr,
        type: result.type || ''
    };
}